<script>
	const _ = require('underscore');
	const Vue = require('vue');
	const model = require('model/model');
	const pubsub = require('events/pubsub');
	const Grading = require('../../../readworks-grading');
	const assignmentService = require('services/assignmentService');
	const utilities = require('utilities');

	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const STUDENT_NOTIFICATION_MODAL_DISMISS = accountSettingsUtilities.settings.STUDENT_NOTIFICATION_MODAL_DISMISS;

	const TYPE_MULTIPLE_CHOICE = 0;
	const TYPE_WRITTEN_ANSWER = 1;
	const TYPE_CLICK_TOUCH_WORD = 2;
	const TYPE_WHO_WHAT = 3;
	const TYPE_EXTERNAL_ACTIVITY = 4;
	const TYPE_IMAGE_ANSWER = 5;
	const TYPE_VOCAB_MULTIPLE_CHOICE = 6;
	const TYPE_SPOKEN = 7;
	const TYPE_TRUE_FALSE = 8;

	const scrollManager = require('ui/core/scrollManager');

	module.exports = {
		props: ['article', 'assessment', 'ordered-students', 'route-context', 'assignment-id', 'question-sets'],
		components: {
			'overdue-icon': require('components/overdue-icon.vue').default
		},
		modelData: {
			qset: 'questionSetId'
		},
		data() {
			return {
				// These 2 variables are used to show the yellow fade for a student and possibly a subQuestion
				// when the teacher has got here by following a link
				highlightStudent: null,
				openNote: null,
				highlightQuestion: null,

				// an array of question objects from the product, then augmented with data from
				// the assessment, see addStudentQuestionData(...)
				assessedQuestions: [],
				// letters for answers
				letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
				TYPE_MULTIPLE_CHOICE,
				TYPE_WRITTEN_ANSWER,
				TYPE_CLICK_TOUCH_WORD,
				TYPE_WHO_WHAT,
				TYPE_EXTERNAL_ACTIVITY,
				TYPE_IMAGE_ANSWER,
				TYPE_VOCAB_MULTIPLE_CHOICE,
				TYPE_SPOKEN,
				TYPE_TRUE_FALSE,
				notificationModalDismiss: false
			};
		},
		computed: {
			showResults() {
				let show = true;
				let assessment = this.assessment;

				if (assessment && assessment.showResults === false) {
					show = false;
				}

				return show;
			}
		},
		created() {
			this.checkStudentNotificationModalDismiss();

			this.highlightStudent = model.get('student') || null;
			this.openNote = model.get('noteId') || null;
			this.highlightQuestion = model.get('selectedQID') || null;

			// Should set state on attach, but only once
			model.remove('student');
			model.remove('noteId');
			model.remove('selectedQID');
		},
		methods: {
			getFirstUnscoredStudent() {
				if (this.highlightQuestion) {
					if (this.highlightStudent) {
						return;
					}

					const question = this.assessedQuestions.find(q => q.qid === this.highlightQuestion);

					if (question) {
						const { uid } =
							this.orderedStudents.find(student => {
								const { hasWorkspace, submitted } = student;
								const hasAnswer = question.studentTextAnswers[student.uid];
								const hasScore = question.teacherScores[student.uid] !== undefined;
								return hasWorkspace && submitted && hasAnswer && !hasScore;
							}) || {};

						if (uid) {
							this.highlightStudent = uid;
						}
					}
				}
			},
			navigateToQuestion(id) {
				// TODO switch this DOM querying to use "ref" directive when upgraded to Vue 2 or higher
				const questionRow = this.$el.querySelector(`#question-${id}`);

				if (questionRow) {
					const top = questionRow.offsetTop;
					const position = top;
					scrollManager(position, {
						priority: 2,
						duration: 250
					});
				}
			},
			navigateToHighlightedStudent() {
				if (this.assessedQuestions.length > 0) {
					this.getFirstUnscoredStudent();
					const highlightQuestion = this.highlightQuestion;
					const highlightStudent = this.highlightStudent;

					if (highlightQuestion && highlightStudent) {
						// TODO switch this DOM querying to use "ref" directive when upgraded to Vue 2 or higher
						const questionRow = this.$el.querySelector(`[data-question-id="${highlightQuestion}"]`);

						if (questionRow) {
							const studentRow = questionRow.querySelector(`[data-student-id="${highlightStudent}"]`);

							if (studentRow) {
								const top = studentRow.offsetTop;
								const position = top;
								scrollManager(position, {
									priority: 2,
									duration: 350
								});
							}
						}
					}
				}

				if (this.openNote) {
					setTimeout(function () {
						pubsub.publish('open-note', {
							uid: this.highlightStudent,
							qid: this.openNote
						});
					}, 1000);
				}
			},
			teacherAnswer: function (question, uid, score, subQuestionId) {
				var self = this;
				var updatedScore = parseFloat(score);
				let notificationModalDismiss = this.notificationModalDismiss;
				let hasUnscoredQuestions = false;
				let forwardScore = false;

				if (isNaN(updatedScore)) {
					updatedScore = '';
				}

				var teacherGrade = {
					score: updatedScore,
					questionSetId: parseInt(this.questionSetId),
					questionId: parseInt(question.qid),
					questionType: parseInt(question.type)
				};

				if (question.type === Grading.TYPE_WHO_WHAT) {
					teacherGrade.subQuestionId = parseInt(subQuestionId);
				}

				assignmentService
					.teacherGradeQuestion({
						uid: uid,
						assignmentId: this.assignmentId,
						teacherGrade: teacherGrade
					})
					.then(function () {
						// on success, change the assessment so that results are visible in the class results page
						_.each(self.assessment.students[uid].answers[teacherGrade.questionSetId], function (q) {
							if (q.qid === teacherGrade.questionId) {
								if (typeof q.score !== 'number') {
									forwardScore = true;
								}

								if (question.type === Grading.TYPE_WHO_WHAT) {
									q.subQuestions[teacherGrade.subQuestionId].score = score;
								} else {
									q.score = score;
								}
							}
						});

						let expressqsMap = (self.assessment.options.expressqs || []).reduce((acc, qsid) => {
							acc[qsid] = true;
							return acc;
						}, {});

						self.assessment.options.qs.forEach(qsid => {
							if (!expressqsMap[qsid]) {
								self.assessment.students[uid].answers[qsid].forEach(q => {
									if (typeof q.score !== 'number' && !Grading.questionTypeIsScorable(q.questionType)) {
										hasUnscoredQuestions = true;
									}
								});
							}
						});

						if (!hasUnscoredQuestions && forwardScore && !notificationModalDismiss) {
							utilities.openModal('#modal-student-notification');
						}
					});
			},
			doQuestionAssessment() {
				this.assessedQuestions = [];
				const assessment = this.assessment || {};
				const { classCode } = assessment;
				const assignmentId = this.assignmentId;
				const questionSetId = this.questionSetId;

				if (classCode && assignmentId && questionSetId) {
					assignmentService
						.teacherGetDetailedAssignmentResults({
							classCode,
							assignmentId,
							questionSetId
						})
						.then(qsAssessment => {
							const expressqs = (assessment.options && assessment.options.expressqs) || [];
							const expressOnly = expressqs.includes(parseInt(questionSetId));

							const questions = this.article.getQuestions(questionSetId, expressOnly);

							// make a lookup table of index to student uid, so that we can
							// match up answers to the students who made them
							const studentIndexToUid = qsAssessment.studentInfo.reduce((acc, { uid }, index) => {
								acc[index] = uid;
								return acc;
							}, {});

							const qAssessmentById = qsAssessment.questions.reduce((acc, question) => {
								acc[question.qid] = question;
								return acc;
							}, {});

							questions.forEach(q => {
								this.addStudentQuestionData(q, qAssessmentById[q.qid], studentIndexToUid, questions);
							});

							this.assessedQuestions = [...questions];

							Vue.nextTick(() => {
								this.navigateToHighlightedStudent();
							});
						});
				}
			},
			addStudentQuestionData: function (question, questionAssessment, studentIndexToUid) {
				var self = this;

				if (!questionAssessment) {
					return;
				}

				///////////////////////
				// add answer studentPercent, percentage of students that went with that answer
				var totalAnswered = 0;
				var answerCountsById = {};
				_.each(questionAssessment.answersByStudent, function (ans) {
					if (!ans || !ans.answered) {
						return;
					}

					totalAnswered++;
					if (Grading.questionTypeIsScorable(ans.questionType)) {
						answerCountsById[ans.answerId] = (answerCountsById[ans.answerId] || 0) + 1;
					}
				});

				if (totalAnswered > 0) {
					// no division by zero today
					_.each(question.answers, function (ans) {
						var count = answerCountsById[ans.answerId] || 0;
						ans.studentPercent = Math.round((count / totalAnswered) * 100);
					});
				}

				///////////////////////
				// now setup:
				// - question.studentAnswerIndexes[uid]
				// - question.studentScore[uid]
				// - questionInfo.studentTextAnswers[uid]
				var answerIndexById = {};
				_.each(question.answers, function (a, idx) {
					answerIndexById[a.answerId] = idx;
				});

				question.assignmentId = self.assignmentId;
				question.qsid = this.questionSetId;
				question.studentAnswerIndexes = {};
				question.studentScore = {};
				question.studentTextAnswers = {};
				question.studentSubQuestionTexts = {};
				question.studentSubQuestionTeacherScores = {};
				question.teacherScores = {};
				question.teacherGradeSettersByUid = {};

				_.each(question.subQuestions, function (sq) {
					sq.teacherGradeSettersByUid = {};
				});

				_.each(questionAssessment.answersByStudent, function (ans, idx) {
					var uid = studentIndexToUid[idx];

					question.teacherScores[uid] = ans.score;

					question.teacherGradeSettersByUid[uid] = function (score) {
						self.teacherAnswer(question, uid, score);
					};

					_.each(question.subQuestions, function (sq) {
						sq.teacherGradeSettersByUid[uid] = function (score) {
							self.teacherAnswer(question, uid, score, sq.qid);
						};
					});

					if (ans) {
						question.studentAnswerIndexes[uid] = answerIndexById[ans.answerId];
						question.studentScore[uid] = ans.score;
						question.studentTextAnswers[uid] = ans.answerText;
						if (!question.studentSubQuestionTexts[uid]) {
							question.studentSubQuestionTexts[uid] = {};
						}
						if (!question.studentSubQuestionTeacherScores[uid]) {
							question.studentSubQuestionTeacherScores[uid] = {};
						}
						_.each(ans.subQuestions || {}, function (sub, subQId) {
							question.studentSubQuestionTexts[uid][subQId] = sub.answerText;
							question.studentSubQuestionTeacherScores[uid][subQId] = sub.score;
						});
					}
				});
			},
			checkStudentNotificationModalDismiss() {
				accountSettingsUtilities.read(STUDENT_NOTIFICATION_MODAL_DISMISS).then(value => {
					this.notificationModalDismiss = !!value;
				});
			},
			dismissStudentNotificationSetting() {
				accountSettingsUtilities.update(STUDENT_NOTIFICATION_MODAL_DISMISS, true);
				this.dismissStudentNotificationModal();
			},
			dismissStudentNotificationModal() {
				this.notificationModalDismiss = true;
				utilities.closeModals();
			},
			getQuestionText(questionInfo) {
				const { type, question, directionStudent } = questionInfo;

				if ([TYPE_MULTIPLE_CHOICE, TYPE_WRITTEN_ANSWER, TYPE_VOCAB_MULTIPLE_CHOICE, TYPE_IMAGE_ANSWER].includes(type)) {
					return question;
				}

				if ([TYPE_CLICK_TOUCH_WORD, TYPE_WHO_WHAT].includes(type)) {
					return directionStudent;
				}

				if ([TYPE_EXTERNAL_ACTIVITY, TYPE_SPOKEN].includes(type)) {
					return directionStudent || question;
				}

				return '';
			}
		},
		watch: {
			questionSetId() {
				this.doQuestionAssessment();
			}
		}
	};
</script>
<template>
	<div class="assignment-questions">
		<template v-for="(questionInfo, index) in assessedQuestions">
			<section
				class="assignment-question"
				:id="`question-${index + 1}`"
				:data-question-id="questionInfo.qid">
				<div class="question-answer-wrapper">
					<header class="assignment-question-header">
						<div class="wrapper">
							<div class="stopper">
								<ol class="assignment-question-header-pagination">
									<li v-if="index !== 0">
										<button
											class="button -link"
											@click="navigateToQuestion(index)">
											<i
												class="icon-prev"
												aria-hidden="true"></i>
											<span class="hidden-visually">Previous</span>
										</button>
									</li>
									<li>{{ index + 1 }}/{{ assessedQuestions.length }}</li>
									<li>
										<button
											class="button -link"
											@click="navigateToQuestion(index + 2)">
											<i
												v-if="index !== assessedQuestions.length - 1"
												class="icon-next"
												aria-hidden="true"></i>
											<i
												v-if="index === assessedQuestions.length - 1"
												style="visibility: hidden"
												class="icon-next"
												aria-hidden="true"></i>
											<span class="hidden-visually">Next</span>
										</button>
									</li>
								</ol>
								<h2 class="assignment-question-header-title">
									<!-- external activity needs special numbering -->
									{{ index + 1 }}.
									<span v-html="getQuestionText(questionInfo)"></span>
								</h2>
								<template v-if="questionInfo.type === TYPE_MULTIPLE_CHOICE || questionInfo.type === TYPE_VOCAB_MULTIPLE_CHOICE">
									<div class="assignment-question-answers margin-top-medium">
										<div
											class="grid"
											v-for="(answer, answerIndex) in questionInfo.answers"
											:key="answer.answer"
											:class="{ correct: answer.correct }">
											<div class="grid-col-1"><span v-show="answer.correct">Answer</span>&nbsp;</div>
											<div class="grid-col-1">{{ answer.studentPercent || '0' }}%</div>
											<div class="grid-col-10">{{ letters[answerIndex] }}. <span v-html="answer.answer"></span></div>
										</div>
									</div>
								</template>
								<template v-if="questionInfo.type === TYPE_IMAGE_ANSWER">
									<div class="assignment-question-answers">
										<h3>Answer</h3>
										<div class="assignment-question-answers-results">
											<ol class="image-list">
												<li
													v-for="(answer, answerIndex) in questionInfo.answers"
													:key="answer.answer"
													:class="{ correct: answer.correct }">
													<em
														><span style="float: right"> {{ answer.studentPercent || '0' }}%</span>
														<div>{{ letters[answerIndex] }}.</div>
														<span v-html="answer.answer"></span>
													</em>
												</li>
											</ol>
										</div>
									</div>
								</template>
								<template
									v-if="questionInfo.type === TYPE_WRITTEN_ANSWER || questionInfo.type === TYPE_EXTERNAL_ACTIVITY || questionInfo.type === TYPE_SPOKEN">
									<div class="assignment-question-answers">
										<span
											><strong>ANSWER:&nbsp;</strong>
											<span
												v-if="questionInfo.answers"
												v-html="questionInfo.answers[0].answer"></span
										></span>
									</div>
								</template>
								<template v-if="questionInfo.type === TYPE_WHO_WHAT">
									<div class="assignment-question-answers">
										<div class="assignment-question-answers-results -definitions">
											<p v-html="questionInfo.excerpts[0]"></p>
											<dl>
												<template v-for="(subq, subqIndex) in questionInfo.subQuestions">
													<dt>{{ letters[subqIndex] }} <span v-html="subq.question"></span></dt>
													<dd><b>Answer:</b> <span v-html="subq.answers[0].answer"></span></dd>
												</template>
											</dl>
										</div>
									</div>
								</template>
								<template v-if="questionInfo.type === TYPE_CLICK_TOUCH_WORD">
									<div class="assignment-question-answers">
										<div class="assignment-question-answers-results">
											<p
												v-for="exc in questionInfo.excerpts"
												:key="exc"
												v-html="exc"></p>
										</div>
									</div>
								</template>
							</div>
						</div>
					</header>
				</div>
				<!-- Question Template "1" (0 & 5) -->
				<template v-if="questionInfo.type === TYPE_MULTIPLE_CHOICE || questionInfo.type === TYPE_VOCAB_MULTIPLE_CHOICE">
					<div class="assignment-question-student-answers wrapper">
						<div class="stopper">
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5em 0"
								class="grid">
								<div class="grid-col-2"><strong>STUDENT</strong></div>
								<div class="grid-col-1"><strong>ANSWER</strong></div>
								<div class="grid-col-9"></div>
							</div>
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5em 0"
								class="grid"
								v-for="student in orderedStudents"
								:key="student.uid">
								<div class="grid-col-2">
									<a
										v-if="student.hasWorkspace"
										:href="'#!assessmentTab:results/student:' + student.uid + '/resultsTab:studentresults/qset:' + questionSetId">
										{{ student.firstName }} {{ student.lastName }}
									</a>
									<template v-else>{{ student.firstName }} {{ student.lastName }}</template>
									<overdue-icon v-if="student.overdue"></overdue-icon>
								</div>
								<div
									class="answer grid-col-1"
									:data-student-id="student.uid"
									:class="{
										'yellow-fade-in': questionInfo.qid == highlightQuestion && student.uid === highlightStudent,
										correct: questionInfo.studentScore[student.uid],
										incorrect: !questionInfo.studentScore[student.uid]
									}">
									{{ letters[questionInfo.studentAnswerIndexes[student.uid]] }}&nbsp;
								</div>
								<div class="grid-col-9">
									<answer-note
										v-if="student.submitted"
										:student="student"
										:question-info="questionInfo"
										:assessment="assessment"></answer-note>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-if="questionInfo.type === TYPE_IMAGE_ANSWER">
					<div class="wrapper">
						<div class="stopper">
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5em 0"
								class="grid">
								<div class="grid-col-2"><strong>STUDENT</strong></div>
								<div class="grid-col-1"><strong>ANSWER</strong></div>
								<div class="grid-col-9"></div>
							</div>
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5em 0"
								class="grid"
								v-for="student in orderedStudents"
								:key="student.uid">
								<div class="grid-col-2">
									<a
										v-if="student.hasWorkspace"
										:href="'#!assessmentTab:results/student:' + student.uid + '/resultsTab:studentresults/qset:' + questionSetId">
										{{ student.firstName }} {{ student.lastName }}
									</a>
									<template v-else>{{ student.firstName }} {{ student.lastName }}</template>
									<overdue-icon v-if="student.overdue"></overdue-icon>
								</div>
								<div
									class="answer grid-col-1"
									:data-student-id="student.uid"
									:class="{
										'yellow-fade-in': questionInfo.qid == highlightQuestion && student.uid === highlightStudent,
										'-correct': questionInfo.studentScore[student.uid],
										'-incorrect': !questionInfo.studentScore[student.uid]
									}">
									{{ letters[questionInfo.studentAnswerIndexes[student.uid]] }}&nbsp;
								</div>
								<div class="grid-col-9">
									<answer-note
										v-if="student.submitted"
										:student="student"
										:question-info="questionInfo"
										:assessment="assessment"></answer-note>
								</div>
							</div>
						</div>
					</div>
				</template>
				<!-- Question Template "2" (type 1) -->
				<template v-if="questionInfo.type === TYPE_WRITTEN_ANSWER">
					<div class="wrapper">
						<div class="stopper">
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5rem 0"
								v-for="student in orderedStudents"
								:key="student.uid">
								<div>
									<strong style="width: 20rem; display: inline-block">
										<a
											v-if="student.hasWorkspace"
											:href="'#!assessmentTab:results/student:' + student.uid + '/resultsTab:studentresults/qset:' + questionSetId">
											{{ student.firstName }} {{ student.lastName }}
										</a>
										<template v-else>{{ student.firstName }} {{ student.lastName }}</template>
									</strong>
									<overdue-icon v-if="student.overdue"></overdue-icon>
									<div
										class="answer"
										style="display: inline-block"
										:data-student-id="student.uid"
										:class="{ 'yellow-fade-in': questionInfo.qid == highlightQuestion && student.uid === highlightStudent }">
										<question-score-chooser
											:isdisabled="
												!student.hasWorkspace ||
												(!assessment.closed && !student.submitted) ||
												(!student.submitted && assessment.closed && student.edd > assessment.closed)
											"
											:change-callback="questionInfo.teacherGradeSettersByUid[student.uid]"
											:val.sync="questionInfo.teacherScores[student.uid]"
											:closed="assessment.closed">
										</question-score-chooser>
										<div style="display: inline-block">
											<answer-note
												v-if="student.submitted"
												:student="student"
												:assessment="assessment"
												:question-info="questionInfo"></answer-note>
										</div>
									</div>
								</div>
								<div>
									{{ questionInfo.studentTextAnswers[student.uid] }}
									<template v-if="student.submitted && !questionInfo.studentTextAnswers[student.uid]">
										<span class="question-unanswered">Not answered</span>
									</template>
								</div>
							</div>
						</div>
					</div>
				</template>
				<!-- End Question Template 2 -->
				<!-- Question Template "3" (type 3) -->
				<template v-if="questionInfo.type === TYPE_WHO_WHAT">
					<div class="wrapper">
						<div class="stopper">
							<table>
								<thead>
									<tr>
										<th>Student</th>
										<th>Answer</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="student in orderedStudents"
										:key="student.uid">
										<td>
											<span v-scroll-target="questionSetId + '/' + $parent.$index + '/' + student.uid"> {{ student.firstName }} {{ student.lastName }} </span>
											<overdue-icon v-if="student.overdue"></overdue-icon>
										</td>
										<td class="answer">
											<ol v-if="questionInfo.studentSubQuestionTexts[student.uid]">
												<li
													v-for="(subq, subqIndex) in questionInfo.subQuestions"
													:key="subq.qid"
													:data-student-id="student.uid"
													:class="{
														'-first-subquestion': subqIndex === 0,
														'yellow-fade-in': questionInfo.qid == highlightQuestion && student.uid === highlightStudent && subq.qid == highlightSubQuestion
													}">
													<template v-if="subqIndex === 0"> {{ letters[subqIndex] }}. (Answer provided) </template>
													<template v-if="subqIndex !== 0">
														<!-- float:right score chooser for wide screens -->
														<question-score-chooser
															:isdisabled="!student.submitted"
															class="-wide"
															:change-callback="subq.teacherGradeSettersByUid[student.uid]"
															:val.sync="questionInfo.studentSubQuestionTeacherScores[student.uid][subq.qid]">
														</question-score-chooser>
														<!-- student answer -->
														<p class="written-answer-submitted">
															{{ letters[subqIndex] }}.
															<template v-if="questionInfo.studentSubQuestionTexts[student.uid][subq.qid]">
																{{ questionInfo.studentSubQuestionTexts[student.uid][subq.qid] }}
															</template>
															<template v-if="student.submitted && !questionInfo.studentSubQuestionTexts[student.uid][subq.qid]">
																<span class="no-answer">not answered</span>
															</template>
														</p>
														<!-- display:block score chooser for narrow screens -->
														<question-score-chooser
															:isdisabled="!student.submitted"
															class="-narrow"
															:change-callback="subq.teacherGradeSettersByUid[student.uid]"
															:val.sync="questionInfo.studentSubQuestionTeacherScores[student.uid][subq.qid]">
														</question-score-chooser>
													</template>
												</li>
											</ol>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</template>
				<!-- End Question Template 3 -->
				<!-- Question Template "4" (type 2) -->
				<template v-if="questionInfo.type === TYPE_CLICK_TOUCH_WORD">
					<p>(Unscored)</p>
				</template>
				<!-- End Question Template 4 -->
				<template v-if="questionInfo.type === TYPE_EXTERNAL_ACTIVITY || questionInfo.type === TYPE_SPOKEN">
					<div class="wrapper">
						<div class="stopper">
							<div
								style="border-bottom: 1px solid #dcdee0; padding: 0.5rem 0"
								v-for="student in orderedStudents"
								:key="student.uid">
								<div>
									<strong style="width: 20rem; display: inline-block">
										<a
											v-if="student.hasWorkspace"
											:href="'#!assessmentTab:results/student:' + student.uid + '/resultsTab:studentresults/qset:' + questionSetId">
											{{ student.firstName }} {{ student.lastName }}
										</a>
										<template v-else>{{ student.firstName }} {{ student.lastName }}</template>
									</strong>
									<overdue-icon v-if="student.overdue"></overdue-icon>
									<div
										class="answer"
										style="display: inline-block"
										:data-student-id="student.uid"
										:class="{ 'yellow-fade-in': questionInfo.qid == highlightQuestion && student.uid === highlightStudent }">
										<question-score-chooser
											:isdisabled="
												!student.hasWorkspace ||
												(!assessment.closed && !student.submitted) ||
												(!student.submitted && assessment.closed && student.edd > assessment.closed)
											"
											:change-callback="questionInfo.teacherGradeSettersByUid[student.uid]"
											:val.sync="questionInfo.teacherScores[student.uid]"
											:closed="assessment.closed">
										</question-score-chooser>
										<div style="display: inline-block">
											<answer-note
												v-if="student.submitted"
												:student="student"
												:assessment="assessment"
												:question-info="questionInfo"></answer-note>
										</div>
									</div>
								</div>
								<div v-if="questionInfo.type === TYPE_EXTERNAL_ACTIVITY">(drawing should be done outside of the website)</div>
								<div v-if="questionInfo.type === TYPE_SPOKEN">(students should answer out loud)</div>
							</div>
						</div>
					</div>
				</template>
			</section>
		</template>
		<modal
			ref="modal"
			id="modal-student-notification"
			:centered="true">
			<div slot="header-container">
				<h2>Student Notifications</h2>
			</div>
			<div slot="content">
				<template v-if="showResults">
					You have fully graded a student’s assignment. As you finish grading for each student, notifications are automatically sent to their ReadWorks
					accounts, and students will see them the next time they log in.
				</template>
				<template v-if="!showResults">
					You have fully graded a student’s assignment. As you finish grading for each student, notifications are automatically queued to be sent to their
					ReadWorks account. These notifications will not appear until you select “Share results with students” in Assignments & Progress.
				</template>
				<div>
					<button
						class="button margin-top-medium"
						@click="dismissStudentNotificationModal">
						Ok
					</button>
				</div>
				<div
					class="dismiss-student-notification font-small text-muted margin-top-medium link-grey"
					@click="dismissStudentNotificationSetting">
					Don't show this message again.
				</div>
			</div>
		</modal>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';

	.assignment-questions {
		.assignment-question-header-pagination button {
			color: $c-blue;
		}

		.stopper {
			max-width: 52rem;
		}
	}
</style>
